import { render, staticRenderFns } from "./Prequiz.vue?vue&type=template&id=0f279314&scoped=true&"
import script from "./Prequiz.vue?vue&type=script&lang=js&"
export * from "./Prequiz.vue?vue&type=script&lang=js&"
import style0 from "./Prequiz.vue?vue&type=style&index=0&id=0f279314&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f279314",
  null
  
)

export default component.exports